export enum Protocol {
  FTP = 'ftp://',
  HTTP = 'http://',
  HTTPS = 'https://',
  MAIL_TO = 'mailto:',
}
